<template>
    <v-row style=" font-family: Arial, Helvetica, sans-serif; width: 1300px; height: 300px; background-color: #232323; color: white; font-size: 1.2rem;" class="px-0 mx-0 ml-1" align="center" justify="center">
        <v-col cols="2" align="center" class="py-0 my-0 px-0 mx-0">
            <img
                :src="`${assetsUrl}/${displayedTeam?.logo}`"
                width="200px"
                max-height="auto"
                class="team-logo-badge"
                contain
                style="margin-right: 8px;"
            >
        </v-col>
        <!-- players for the currently visible team -->
        <v-col v-for="player in displayedPlayers" :key="player.id" cols="2" align="center" class="py-0 my-0">
            <v-row class="my-0 mx-0 px-0" style="background-color: #232323;" align="center" justify="center">
                <v-col cols="12">
                    <img
                        :src="`${assetsUrl}/${player.image}`"
                        width="auto"
                        height="100px"
                        contain
                        @error="$event.target.src = defaultPlayerImg"
                    >
                    <div class="player-name-ellipsis">
                        #{{ player.jersey }} {{ player.name }}
                    </div>
                </v-col>
                <v-col cols="12" align="center" class="font-weight-bold px-0">
                    <span> {{ player.stats[0]?.points ?? 0 }} </span>
                    <span class="custom-teal-text">{{ 'points' }}</span>
                    <div cols="12" align="center" class="px-0 py-0 my-0" style="font-size: 1.2rem;">
                        <span class="custom-teal-text font-weight-bold mr-1">fouls</span>
                        <span v-for="i in foulsCount(player)" :key="`i-${i}`">
                            <v-icon :color="foulsCount(player) >= 5 ? 'red' : 'teal'">mdi-minus-thick</v-icon>
                        </span>
                        <span v-for="j in remainingFouls(player)" :key="`j-${j}`">
                            <v-icon color="white">mdi-minus-thick</v-icon>
                        </span>
                    </div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    import matchService from '@/services/match'
    export default {
        props: {
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                defaultPlayerImg: require('@/assets/default_player.png'),
                match: null,
                activePlayers: {
                    team1: [],
                    team2: []
                },
                // rotation state
                visibleTeamIndex: 1, // 1 => team1, 2 => team2
                activeTimer: null,
                rotateIntervalMs: 10000,
                rotationStage: 0 // renamed from _rotationStage
            }
        },
        computed: {
            displayedPlayers() {
                return this.visibleTeamIndex === 1 ? this.activePlayers.team1 : this.activePlayers.team2
            },
            displayedTeam() {
                return this.visibleTeamIndex === 1 ? this.match?.team1 : this.match?.team2
            }
        },
        mounted() {
            this.fetchMatch(this.$route.params.id).then((resp) => {
                this.match = resp
                this.getActivePlayers().then(() => {
                    this.startRotation()
                })
            })
        },
        beforeDestroy() {
            this.stopRotation()
        },
        methods: {
            fetchMatch(matchId) {
                return matchService.getMatch(matchId).then(resp => {
                    return resp.data
                })
            },
            async getActivePlayers() {
                try {
                    const resp = await matchService.getActivePlayers(this.$route.params.id)
                    // reset arrays to avoid duplicates on repeated calls
                    this.activePlayers.team1 = []
                    this.activePlayers.team2 = []

                    resp.data.team1Players.forEach(playerRef => {
                        const p = this.match.team1.players.find(p => p.id === playerRef.playerId)
                        if (p) this.activePlayers.team1.push(p)
                    })
                    resp.data.team2Players.forEach(playerRef => {
                        const p = this.match.team2.players.find(p => p.id === playerRef.playerId)
                        if (p) this.activePlayers.team2.push(p)
                    })
                } catch (e) {
                    console.error('Failed to load active players', e)
                }
            },
            startRotation() {
                this.stopRotation()
                this.rotationStage = 0
                // show team1 first
                this.visibleTeamIndex = 1
                this.rotationStage = 1

                // after rotateIntervalMs show team2
                this.activeTimer = setTimeout(() => {
                    this.visibleTeamIndex = 2
                    this.rotationStage = 2

                    // after another rotateIntervalMs emit and stop
                    this.activeTimer = setTimeout(() => {
                        // finished showing both teams once
                        this.$emit('setShowScreen')
                        this.stopRotation()
                    }, this.rotateIntervalMs)
                }, this.rotateIntervalMs)
            },
            stopRotation() {
                if (this.activeTimer) {
                    clearTimeout(this.activeTimer)
                    this.activeTimer = null
                }
            },
            foulsCount(player) {
                const pf = player?.stats?.[0]?.personalFouls || 0
                const tf = player?.stats?.[0]?.technicalFouls || 0
                const total = pf + tf
                return Math.min(5, Math.max(0, total))
            },
            remainingFouls(player) {
                const rem = 5 - this.foulsCount(player)
                return rem > 0 ? rem : 0
            }
        }
    }
</script>

<style>
    .v-progress-circular__info {
        display: block;
    }

    .icon-outline {
        text-shadow:
            -1px -1px 0 #000,
            1px -1px 0 #000,
            -1px  1px 0 #000,
            1px  1px 0 #000;
    }

    .circular-border {
        display: inline-flex;
        border: 2px solid #fff;     /* white border */
        padding: 2px;               /* space between border and ring */
    }

    .player-line {
        display: flex;
        align-items: center;
    }

    .player-name-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 500px; /* Adjust this value as needed */
    }

    .team-logo-badge {
        width: 100px;
        height: 100px;
        padding: 8px;
        border-radius: 50%;
        background-color: #fff;
        object-fit: contain;
        display: inline-block;
    }
</style>
